"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleModelDescription = void 0;
const core_1 = require("@angular/core");
let VehicleModelDescription = class VehicleModelDescription {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleModelDescription.prototype, "modelData", void 0);
VehicleModelDescription = __decorate([
    (0, core_1.Component)({
        selector: '[vehicle-model-description]',
        template: `
  {{ modelData.modelDescription }}
  <ng-template *ngIf="modelData.engine?.cubicCapacity">{{ modelData.engine?.cubicCapacity / 1000 | roundUp }}</ng-template>
  <vehicle-fuel-type *ngIf="modelData.engine?.fuel?.type" [fuelType]="modelData.engine?.fuel?.type"></vehicle-fuel-type>
  <ng-template [ngIf]="modelData.engine?.power">{{ modelData.engine?.power }} kW ({{ modelData.engine?.power * 1.35962 | number: '1.0-0' }} PS)</ng-template>
  <vehicle-transmission-short *ngIf="modelData.engine?.transmission?.type" [transmission]="modelData.engine?.transmission?.type"></vehicle-transmission-short>
  <ng-template [ngIf]="modelData.engine?.transmission?.gearCount"> {{ modelData.engine?.transmission?.gearCount }}</ng-template>
  <vehicle-drivetrain *ngIf="modelData.engine?.drivetrain" [drivetrain]="modelData.engine?.drivetrain"></vehicle-drivetrain>
  <ng-template [ngIf]="modelData.modelyear">MY {{ modelData.modelyear }}</ng-template>
  `,
    })
], VehicleModelDescription);
exports.VehicleModelDescription = VehicleModelDescription;
